import { ComponentPropsWithoutRef, forwardRef } from "react";
import {
  StyledTriggerButton,
  TriggerButtonProps,
} from "./trigger-button.styles";

export const TriggerButton = forwardRef<
  HTMLButtonElement,
  ComponentPropsWithoutRef<"button"> & TriggerButtonProps
>((props, ref) => {
  return <StyledTriggerButton {...props} ref={ref} />;
});

TriggerButton.displayName = "Dropdown.TriggerButton";
